export const azureDevOpsOverrides = {
	colorBrandBackground: '#0078d4',
	colorBrandBackgroundHover: '#0067b5',
	colorBrandBackgroundPressed: '#0081e3',
	colorBrandBackgroundSelected: 'rgba(55, 96, 145, 1)',

	colorBrandForeground1: '#0081e3',
	colorBrandForeground2: 'rgba(152, 198, 255, 1)',
	colorBrandForeground2Hover: 'rgba(121, 181, 255, 1)',
	colorBrandForeground2Pressed: 'rgba(184, 216, 255, 1)',

	colorBrandForegroundLink: 'rgba(152, 198, 255, 1)',
	colorBrandForegroundLinkHover: 'rgba(121, 181, 255, 1)',
	colorBrandForegroundLinkPressed: 'rgba(0, 120, 212, 1)',

	colorBrandStroke1: 'rgba(0, 120, 212, 1)',
	colorBrandStroke2: 'rgba(0, 103, 181, 1)',

	// Fundo escuro
	colorNeutralBackground1:  'rgba(50, 49, 48, 1)',
	colorNeutralBackground2: 'rgba(37, 36, 35, 1)',
	colorNeutralBackground3: 'rgba(41, 40, 39, 1)',
	colorNeutralBackground5: 'rgba(59, 58, 57, 1)',
	colorNeutralBackground6: 'rgba(72, 70, 68, 1)',

	colorNeutralForeground1: 'rgba(255, 255, 255, 0.95)',
	colorNeutralForeground2: 'rgba(255, 255, 255, 0.8)',
	colorNeutralForeground3: 'rgba(255, 255, 255, 0.5)',
	colorNeutralForeground4: 'rgba(255, 255, 255, 0.3)',

	//
	colorNeutralStencil1: 'rgba(32, 31, 30, )',

	// Vermelho (erro)
	colorStatusDangerBackground3: 'rgba(241, 112, 123, 1)',
	colorStatusDangerBackground3Hover: 'rgba(203, 15, 31, 1)',
	colorStatusDangerBackground3Pressed: 'rgba(184, 14, 28, 1)',
	colorStatusDangerBorder1: 'rgba(232, 17, 35, 1)',
	colorStatusDangerForeground1: 'rgba(241, 112, 123, 1)',

	// Sucesso
	colorStatusSuccessBackground3: 'rgba(146, 195, 83, 1)',
	colorStatusSuccessBorder1: 'rgba(146, 195, 83, 1)',
	colorStatusSuccessForeground1: 'rgba(127, 184, 0, 1)',
};